import React from 'react';
import PropTypes from 'prop-types';

const CircleLoader = ({ width, height }) => (
  <div className="c-bb-uploader-progress-circle">
    <div
      className="c-bb-uploader-progress-circle--pending"
      style={{
        width,
        height,
      }}
    />
  </div>
);

CircleLoader.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

CircleLoader.defaultProps = {
  width: 56,
  height: 56,
};

export default CircleLoader;



// WEBPACK FOOTER //
// ./src/components/Loader/CircleLoader.js